
import React, { useState } from 'react';
import { signInAdmin, signInWithGoogle } from '../firebase';
import { useNavigate } from 'react-router-dom';
import { t } from '../i18n';

export default function AdminLogin(){
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  async function handleSubmit(e){
    e.preventDefault();
    setError(null);
    try {
      await signInAdmin(email, password);
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Sign-in failed');
    }
  }

  async function handleGoogle() {
    setError(null);
    try {
      await signInWithGoogle();
      navigate('/admin');
    } catch (err) {
      setError(err.message || 'Google sign-in failed');
    }
  }

  return (
    <div>
      <div className="container py-4">
        <div className="row justify-content-center">
          <div className="col-12 col-md-5">
            <div className="card shadow-sm">
              <div className="card-body">
                <h3 className="card-title mb-3">{t('adminLogin')}</h3>
                <form onSubmit={handleSubmit}>
                  <div className="mb-2">
                    <input className="form-control" placeholder={t('email')} value={email} onChange={e=>setEmail(e.target.value)} />
                  </div>
                  <div className="mb-2">
                    <input className="form-control" placeholder={t('password')} type="password" value={password} onChange={e=>setPassword(e.target.value)} />
                  </div>
                  <div className="d-flex gap-2">
                    <button className="btn btn-primary" type="submit">{t('signIn')}</button>
                    <button type="button" className="btn btn-outline-danger" onClick={handleGoogle}>{t('signInWithGoogle')}</button>
                  </div>
                </form>
                {error && <div className="text-danger mt-2">{error}</div>}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
